//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { markdownToHTML } from '@/lib/converters'
import { formatDate } from '@/lib/utils'

export default {
  name: 'Announcements',
  props: {
    announcements: {
      type: Array,
      default: []
    }
  },
  methods: {
    markdownToHTML,
    formatDate,
    normalizeAnnouncementType(announcementType) {
      return announcementType.toLowerCase().replace('_', '-')
    }
  }
}
